import {issueAllIssuesTypesUpdateRequiredFields} from '../../utils/analytics-helpers';
import {
  REQUIRED_FIELDS_FETCH_API_FULFILLED,
  REQUIRED_FIELDS_FETCH_API_REJECTED,
  REQUIRED_FIELDS_FETCH_START,
  REQUIRED_FIELDS_UPDATE_API_FULFILLED,
  REQUIRED_FIELDS_UPDATE_API_REJECTED,
  REQUIRED_FIELDS_UPDATE_START,
  trackEvent
} from '../actions';

export const fetchRequiredFields = () => (dispatch, getState, {issuesV2Api}) => {
  dispatch({type: REQUIRED_FIELDS_FETCH_START});

  return issuesV2Api
    .getRequiredFields()
    .then(payload => dispatch({type: REQUIRED_FIELDS_FETCH_API_FULFILLED, payload}))
    .catch(() => dispatch({type: REQUIRED_FIELDS_FETCH_API_REJECTED}));
};

export const serverUpdateRequiredFields = ({modalCallback}) => (dispatch, getState, {issuesV2Api}) => {
  const storeState = getState();
  const state = storeState.requiredFields;
  const fields = state.fields;
  const fieldsWithUpdated = fields.merge(state.changedFields);
  const needsUpdating = Object.keys(fields).some(key => state.fields[key] !== fieldsWithUpdated[key]);

  if (needsUpdating) {
    dispatch({type: REQUIRED_FIELDS_UPDATE_START});
    issuesV2Api
      .updateRequiredFields(fieldsWithUpdated)
      .then(payload => {
        dispatch({type: REQUIRED_FIELDS_UPDATE_API_FULFILLED, payload});
        modalCallback();
      })
      .catch(() => dispatch({type: REQUIRED_FIELDS_UPDATE_API_REJECTED}));
    // only track event if the required fields modal actually had been changed
    dispatch(
      trackEvent(
        issueAllIssuesTypesUpdateRequiredFields({
          active: Object.keys(fields).some(fieldName => fields[fieldName].isRequired)
        })
      )
    );
  } else {
    modalCallback();
  }
};
